import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectStatusCreationError() {
      return getState().error;
    },
    isProjectStatusCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isProjectStatusCreationRequestPending() {
      return getState().request.isPending;
    },
    isProjectStatusCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
